@if (notificationMessage) {
  <div class="flex flex-row w-full rounded-xl p-1 items-center background-{{notificationType}}">
    @switch (notificationType) {
      @case (EmbeddedNotificationType.INFORMATION) {
        <mat-icon class="stroke-{{notificationType}} icon m-2" svgIcon="exclamation-circle"></mat-icon>
      }
      @case (EmbeddedNotificationType.SUCCESS) {
        <mat-icon class="icon m-2" svgIcon="tick-circle"></mat-icon>
      }
      @case (EmbeddedNotificationType.WARNING) {
        <mat-icon class="stroke-{{notificationType}} icon m-2" svgIcon="danger2"></mat-icon>
      }
      @case (EmbeddedNotificationType.ERROR) {
        <mat-icon class="icon m-2" svgIcon="close-circle"></mat-icon>
      }
    }
    <div class="flex flex-col pr-2">
      <div class="text-sm title-{{notificationType}}">{{notificationTitle}}</div>
      <div class="text-xs text-justify">{{notificationMessage}}</div>
    </div>
    @if (enableActionButton) {
      <div class="grow px-1">
        <button class="border-[0.15rem] rounded-lg py-1 px-2 float-right action-button-{{notificationType}}"
                (click)="onActionButtonClick($event)">
          <div class="flex flex-row gap-2 items-center">
            <div class="font-bold text-md text-nowrap">{{actionButtonText}}</div>
            <mat-icon class="stroke-{{notificationType}} icon-sm" svgIcon="arrow-right"></mat-icon>
          </div>
        </button>
      </div>
    }
  </div>
}